import { createFileRoute } from "@tanstack/react-router";
import { AudiencesLibrary } from "@/components/outreach/AudiencesLibrary";
import { useSession } from "@/hooks/use-session";

export const Route = createFileRoute("/_app/_/outreach/audiences")({
	component: OutreachAudiencesPage,
});

function OutreachAudiencesPage() {
	const session = useSession();
	const campaignId = session.campaign?.id;

	if (!campaignId) {
		return (
			<div className="mx-auto max-w-4xl p-6">
				<p className="text-muted-foreground">
					No campaign found. Please complete onboarding first.
				</p>
			</div>
		)
	}

	return <AudiencesLibrary campaignId={campaignId} />;
}
